/**
 * ASCII Hero Engine - Library Entry Point
 * Modular Interactive ASCII Typography & Portrait Canvas Engine
 */

import "./styles/index.css";

// Utilities & Constants
export * from "./constants.js";
export { Easings } from "./utils/easings.js";
export { parseColorToRgb, isPointInPolygon } from "./utils/math.js";

// Core Particle & Dust
export { AsciiParticle } from "./core/AsciiParticle.js";
export { AsciiDustGlyph } from "./core/AsciiDustGlyph.js";

// Interactive Illustrations
export { AsciiIllustration } from "./illustrations/AsciiIllustration.js";
export { AsciiBlurRectangle } from "./illustrations/AsciiBlurRectangle.js";
export { AsciiConcentricCircles, AsciiRippleRings } from "./illustrations/AsciiConcentricCircles.js";

// Timeline Orchestrator
export { AsciiTimeline } from "./timeline/AsciiTimeline.js";

// Master Engine
export { AsciiHeroEngine } from "./engine/AsciiHeroEngine.js";

// Presets and Factory Helpers
export {
  createSideProfileScene,
  createHeroShowcaseScene,
  createTimelineShowcaseScene,
  initHeroPreset,
  initTimelinePreset,
} from "./presets/scenes.js";

import { Easings } from "./utils/easings.js";
import { parseColorToRgb, isPointInPolygon } from "./utils/math.js";
import { AsciiParticle } from "./core/AsciiParticle.js";
import { AsciiDustGlyph } from "./core/AsciiDustGlyph.js";
import { AsciiIllustration } from "./illustrations/AsciiIllustration.js";
import { AsciiBlurRectangle } from "./illustrations/AsciiBlurRectangle.js";
import { AsciiConcentricCircles, AsciiRippleRings } from "./illustrations/AsciiConcentricCircles.js";
import { AsciiTimeline } from "./timeline/AsciiTimeline.js";
import { AsciiHeroEngine } from "./engine/AsciiHeroEngine.js";
import {
  createSideProfileScene,
  createHeroShowcaseScene,
  createTimelineShowcaseScene,
  initHeroPreset,
  initTimelinePreset,
} from "./presets/scenes.js";
import {
  DEFAULT_GLITCH_COLORS,
  DEFAULT_MID_GREY_MASK,
  PROJECT_SHOWCASE_MID_GREY_MASK,
  DEFAULT_BASE_RAMP,
  DEFAULT_BASE_GLITCH,
  DEFAULT_DUST_CHARS,
  DEFAULT_MID_GREY_RAMP,
  DEFAULT_MID_GREY_GLITCH,
  STAR_SVG_PATH,
} from "./constants.js";

// Attach to global window object when running in browser for backward compatibility
if (typeof window !== "undefined") {
  window.Easings = Easings;
  window.parseColorToRgb = parseColorToRgb;
  window.isPointInPolygon = isPointInPolygon;
  window.AsciiParticle = AsciiParticle;
  window.AsciiDustGlyph = AsciiDustGlyph;
  window.AsciiIllustration = AsciiIllustration;
  window.AsciiBlurRectangle = AsciiBlurRectangle;
  window.AsciiConcentricCircles = AsciiConcentricCircles;
  window.AsciiRippleRings = AsciiRippleRings;
  window.AsciiTimeline = AsciiTimeline;
  window.AsciiHeroEngine = AsciiHeroEngine;
  window.createSideProfileScene = createSideProfileScene;
  window.createHeroShowcaseScene = createHeroShowcaseScene;
  window.createTimelineShowcaseScene = createTimelineShowcaseScene;
  window.initHeroPreset = initHeroPreset;
  window.initTimelinePreset = initTimelinePreset;
  window.DEFAULT_GLITCH_COLORS = DEFAULT_GLITCH_COLORS;
  window.DEFAULT_MID_GREY_MASK = DEFAULT_MID_GREY_MASK;
  window.PROJECT_SHOWCASE_MID_GREY_MASK = PROJECT_SHOWCASE_MID_GREY_MASK;
  window.DEFAULT_BASE_RAMP = DEFAULT_BASE_RAMP;
  window.DEFAULT_BASE_GLITCH = DEFAULT_BASE_GLITCH;
  window.DEFAULT_DUST_CHARS = DEFAULT_DUST_CHARS;
  window.DEFAULT_MID_GREY_RAMP = DEFAULT_MID_GREY_RAMP;
  window.DEFAULT_MID_GREY_GLITCH = DEFAULT_MID_GREY_GLITCH;
  window.STAR_SVG_PATH = STAR_SVG_PATH;
}

export default AsciiHeroEngine;
